import { InferType, object, string } from 'yup'

import { EMAIL_REGEX, PHONE_REGEX } from '@/app/constants/regex'
import {
  INVALID_EMAIL_MESSAGE,
  INVALID_PHONE_MESSAGE,
  MAX_EMAIL_LENGTH,
  MIN_AMOUNT,
  REQUIRED_EMAIL_FIELD_MESSAGE,
  REQUIRED_FIELD_MESSAGE,
  REQUIRED_SUM_FIELD_MESSAGE
} from '@/app/constants/validation'
import { formatNumber } from '@/utils/string-formatting'

const MAX_AMOUNT = 1_000_000
const AMOUNT_EXCEEDED = 'Сумма оплаты не более 1 000 000 ₽'

export const acquiringSchema = object().shape({
  amount: string()
    .required(REQUIRED_SUM_FIELD_MESSAGE)
    .test('not-zero', REQUIRED_SUM_FIELD_MESSAGE, value => Number(value) > 0)
    .test(
      'min',
      REQUIRED_SUM_FIELD_MESSAGE,
      value => Number(value) >= MIN_AMOUNT
    )
    .test('max', AMOUNT_EXCEEDED, value => Number(value) <= MAX_AMOUNT)
    .transform((_, originalValue) => formatNumber(originalValue)),
  phone: string()
    .when('$selectedReceiptMethod', ([{ key }], schema) =>
      key === 'phone'
        ? schema
            .required(REQUIRED_FIELD_MESSAGE)
            .matches(PHONE_REGEX, INVALID_PHONE_MESSAGE)
        : schema
    )
    .default(''),
  email: string()
    .when('$selectedReceiptMethod', ([{ key }], schema) =>
      key === 'email'
        ? schema
            .required(REQUIRED_EMAIL_FIELD_MESSAGE)
            .matches(EMAIL_REGEX, INVALID_EMAIL_MESSAGE)
            .max(MAX_EMAIL_LENGTH, INVALID_EMAIL_MESSAGE)
        : schema
    )
    .default('')
})

export type AcquiringFormData = InferType<typeof acquiringSchema>
